import { CreatedAt } from '../Document/CreatedAt.js';
import { BlockLink } from './BlockLink.js';
import { GetStrTotal } from '../Functions/GetStrTotal.js';
import { UCFirst } from '../Functions/UCFirst.js';

export const BlockTitleDate2Link1 = (props) => {
    /*
    Pages/Public/Archive.js
    */
    const { label, items } = props;
    let values;
    switch (label) {
        case 'archive':
            values = [
                { created: items.created, closed: items.closed },
                { name: UCFirst(items.aname), author: items.author },
                { href: '/archives-des-attractions', name: 'Archives' },
                { strTotal: `${items.total} ${GetStrTotal(label, items.total)}` }
            ];
            return (
                <div className="block-title">
                    <div className="block-dates">
                        <CreatedAt label="created" date={values[0].created} />
                        <CreatedAt label="closed" date={values[0].closed} />
                    </div>
                    <div className="title">
                        <div className="title-name">{values[1].name}</div>
                        <div className="title-total-label">{values[3].strTotal}</div>
                        <div className="title-author">{values[1].author}</div>
                        <BlockLink label="link-true" href={values[2].href} name={values[2].name} />
                    </div>
                </div>
            )
        default:
            return (
                <></>
            )
    }
}